import {
    REGISTER_USER,
    REGISTER_SUCCESS,
    API_ERROR,
    REGISTER_EMAIL_CHECK,
    REGISTER_EMAIL_CHECK_SUCCESS,
    REGISTER_PHONE_CHECK,
    REGISTER_PHONE_CHECK_SUCCESS,
    REGISTER_EMAIL_CHECK_FAILURE,
    RESET_API_ERROR,
    CLEAR_STATUS_MSG
  } from "./ActionTypes";
  
  const initialState = {
    error: "",
    loading: false,
  };
  
  const register = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_EMAIL_CHECK:
        state = {
          ...state,
          data:action.payload.data,
          loading: true,
        };
        break;
        case REGISTER_EMAIL_CHECK_SUCCESS:
        state = {
          ...state,
          FailureData:action.payload.data,
          loading: false,
        };
        break;
        case REGISTER_EMAIL_CHECK_FAILURE:
        state = {
          ...state,
          FailureData:action.payload.data,
          loading: false,
        };
        break;
        case REGISTER_PHONE_CHECK:
        state = {
          ...state,
          data:action.payload.data,
          loading: true,
        };
        break;
        case REGISTER_PHONE_CHECK_SUCCESS:
        state = {
          ...state,
          FailureData:action.payload.data,
          loading: false,
        };
        break;
      case CLEAR_STATUS_MSG: // Handle the new action
          state = {
              ...state,
              FailureData: {
                  ...state.FailureData,
                  data: {
                      ...state.FailureData?.data,
                      statusmsg: "", // Clear the status message
                  },
              },
          };
          break;
      case REGISTER_USER:
        state = {
          ...state,
          loading: true,
        };
        break;
      case REGISTER_SUCCESS:
        state = {
          ...state,
          data:action.payload.data,
          loading: false,
        };
        break;
      case API_ERROR:
        state = {
          ...state,
          error: action.payload.data,
          loading: false,
          isUserLogout: false,
        };
        break;
        case RESET_API_ERROR:
          state = {
            ...state,
            error: "",
            loading: false,
          };
          break;
      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default register;
  